<template>
  <v-footer id="pages-core-footer" color="transparent">
    <v-container>
      <v-row align="center" no-gutters>
        <template v-if="this.$store.state.modules.options.app_footer">
          <img
            class="footer-icon"
            width="auto"
            max-width="100%"
            :src="this.$store.state.modules.options.app_footer"
          />
        </template>
        <template v-if="this.$store.state.modules.options.app_footer_1">
          <img
            class="footer-icon"
            width="auto"
            max-width="100%"
            :src="this.$store.state.modules.options.app_footer_1"
          />
        </template>
        <v-spacer class="hidden-sm-and-down" />

        <v-col cols="12" md="auto">
          <div class="body-1 font-weight-light pt-6 pt-md-0 text-center">
            <a @click="$router.push({ name: 'frontend.imprint' })"> {{ $t("imprint") }}</a> | &copy; {{ new Date().getFullYear() }}, by

            <a
              target="_blank"
              :href="'https://' + this.$store.state.modules.options.app_url"
              >{{ this.$store.state.modules.options.app_url }}</a
            >
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: "PagesCoreFooter"
};
</script>

<style lang="sass">
#pages-core-footer
  a
    font-size: .825rem
    font-weight: 500
    text-decoration: none
    text-transform: uppercase
</style>
<style lang="scss" scoped>
.footer-icon {
  height: 100px;
  margin-right: 30px;
  margin-bottom: 25px;
}
@media (max-width: 979px) {
  .footer-icon {
    height: 50px;
    max-width: 100%;
    margin: 20px auto;
  }
}
</style>